import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/assets/apps')({
  component: () => <PageStub title="Smart Apps" description="Business tools and applications" />,
});
